export enum PaymentStatusEnum {
    failed = "FAILED",
    pending = "PENDING",
    captured = "CAPTURED",
    unknown = "UNKNOWN"
}